const initialState = {
    user: {
        info: {
            id: '',
            fname: '',
            lname: '',
            email: '',
            mobile: '',
            nic: '',
            userRoles: [],
            picture: ''
        },
        isAuthenticated: false,
        loading: false,
        isRegister: false,
        isPasswordChg: false,
        isInfoChg: false,
        isProPicUpload: false,
        message: '',
        session: {
            accessToken: '',
            idToken: '',
            refreshToken: ''
        },
        signUp: {
            name: '',
            email: '',
            phone: '',
            companyName: '',
            purpose: '',
            password: '',
            message: '',
            isCreateAccountValidate: false,
            isApplicationValidate: false,
            isLoading: false
        }
    },
    transaction: {
        data: [],
        pagination: {},
        loading: false,
    },
    merchant: {
        id: '',
        apiKey: undefined,
        loading: false,
        isLoading: false,
        privateKey: '',
        publicKey: '',
        endPoint: '',
        isKeyGenerate: false,
        isDownloadPublic: false,
        isDownloadPrivate: false,
        isUpdateEndpoint : false
    },
    insurance: {
        name:'',
        phone:'',
        nic:'',
        email:'',
        policyNo:'',
        nicFrontImg:'',
        nicBackImg:'',
        policy_img:'',
        isLoading:false,
        isExporting:false,
        exportSuccess:false,
        exportFail:false
    },
    userManagement: {
        userId: '',
        status:'',
        userAttributes:{},
        userCreateDate:'',
        userLastModifiedDate:'',
        groups:[],
        enabled:'',
        isLoading: false,
        isEditing: false,
        isUserExist: false
    },
    dashboard: {
        merchantCount: 0,
        userCount: 0,
        isLoading: true,
        trnChart:{},
        ipg: {}
    }
};

export default initialState;